import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import {
  COMMON_PERMISSIONS,
  MODULES_LIST,
  SUB_MODULES_LIST,
} from "../../../utils/helper";
import ManageDesignation from "../../main/configuration/manageDesignation/page";
import CommonRoute from "../commonRoute";
import ManageLeaveSetup from "../../main/configuration/manageLeaveSetup/page";
import ManageBranch from "../../main/configuration/manageBranch/page";
import ManageStaffDirectory from "../../main/hr/staffDirectory/page";
import AddStaffDirectory from "../../main/hr/staffDirectory/addStaff";
import AssignSalary from "../../main/hr/staffDirectory/assignSalary";
import Profile from "../../main/hr/staffDirectory/profile/profile";
import StaffDailyAttendance from "../../main/hr/staffAttendance/page";
import StaffLeave from "../../main/hr/staffLeave/page";
import Holiday from "../../main/hr/holiday/page";
import ManageAllowances from "../../main/hr/manageAllowances/page";
import ManageDeduction from "../../main/hr/manageDeduction/page";
import PayrollReports from "../../main/hr/payrollReport/page";
import AttendanceReports from "../../main/hr/attendanceReport/page";
import GenerateSalary from "../../main/hr/generateSalary/page";
import EmployeeSalarySetup from "../../main/hr/employeeSalarySetup/page";
import ImportStaff from "../../main/hr/staffDirectory/importStaff";
import OnboardingWizard from "../../components/onboarding/OnboardingWizard";
import ImportJobs from "../../main/hr/importJobs/page";
import ManageSalaryStructure from "../../main/hr/manageSalaryStructure/page";
import ManagerDashboard from "../../main/hr/attendanceEnhancements/ManagerDashboard/page";
import ShiftEditor from "../../main/hr/attendanceEnhancements/ShiftEditor/page";
import ShiftDetail from "../../main/hr/attendanceEnhancements/ShiftDetail/page";
import PayrollDashboard from "../../main/hr/payrollManagement/PayrollDashboard/page";
import PayrollRunDetail from "../../main/hr/payrollManagement/PayrollRunDetail/page";
import PayslipViewer from "../../main/hr/payrollManagement/PayslipViewer/page";
import StatutoryReports from "../../main/hr/payrollManagement/StatutoryReports/page";

const hrRoute = [
  {
    path: "/hr/manager-dashboard",
    element: <ManagerDashboard />,
    module: "hr",
    subModule: "attendance",
    bypass: [0, 1], // Super Admin & Workspace Admin
  },
  {
    path: "/hr",
    element: <CommonRoute />,
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: null,
  },
  {
    path: "/hr/onboarding",
    element: <OnboardingWizard />,
  },
  {
    path: "/hr/import-jobs",
    element: <ImportJobs />,
  },
  
  {
    path: "/hr/staff-directory",
    element: <ManageStaffDirectory />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DEPARTMENT,
  },
  {
    path: "/hr/staff-directory/assign/:id",
    element: <AssignSalary />,
  },
  {
    path: "/hr/staff-directory/:action?/:id?",
    element: <AddStaffDirectory />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DEPARTMENT,
  },
   {
    path: "/hr/staff-directory/import",
    element: <ImportStaff />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DEPARTMENT,
  },
  {
    path: "/hr/staff-directory/profile/:id?",
    element: <Profile />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DEPARTMENT,
  },   
  {
    path: "/hr/staff-attendance",
    element: <StaffDailyAttendance />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DESIGNATION,
  },
  {
    path: "/hr/staff-leaves",
    element: <StaffLeave />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE,
  },
  {
    path: "/hr/staff-holidays",
    element: <Holiday />,
    module: "leave",
    subModule: "holiday",
    bypass: [0, 1], // Super Admin & Workspace Admin
  },
  {
    path: "/hr/manage-allowance",
    element: <ManageAllowances />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE,
  },
  {
    path: "/hr/manage-deduction",
    element: <ManageDeduction />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE,
  },
  {
    path: "/hr/manage-salary-structure",
    element: <ManageSalaryStructure />,
  },
  {
    path: "/hr/payroll-reports",
    element: <PayrollReports />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE,
  },
  {
    path: "/hr/generate-salary",
    element: <GenerateSalary />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE,
  },
  {
    path: "/hr/salary-setup",
    element: <EmployeeSalarySetup />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE,
  },
  {
    path: "/hr/attendance-reports",
    element: <AttendanceReports />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE,
  },
  {
    path: "/hr/shift-editor",
    element: <ShiftEditor />,
    module: "hr",
    subModule: "shift",
    bypass: [0, 1], // Super Admin & Workspace Admin
  },
  {
    path: "/hr/shift-editor/:id",
    element: <ShiftDetail />,
    module: "hr",
    subModule: "shift",
    bypass: [0, 1], // Super Admin & Workspace Admin
  },
  {
    path: "/hr/payroll-dashboard",
    element: <PayrollDashboard />,
    module: "hr",
    subModule: "payroll",
    bypass: [0, 1], // Super Admin & Workspace Admin
  },
  {
    path: "/hr/payroll-runs/:runId",
    element: <PayrollRunDetail />,
    module: "hr",
    subModule: "payroll",
    bypass: [0, 1],
  },
  {
    path: "/hr/payslips/:employeeId?",
    element: <PayslipViewer />,
    module: "payroll", // Changed from "hr" to match menuConfig
    subModule: "payslips",
    bypass: [0, 1, 2], // Super Admin, Workspace Admin, and all Staff can access
  },
  {
    path: "/hr/statutory-reports",
    element: <StatutoryReports />,
    module: "hr",
    subModule: "statutory-reports",
    bypass: [0, 1],
  },
  
  
];

export default function renderHrRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            >
             
            </ProtectedRoute>
          }
        >
          {/* Render child routes without extra permission checks */}
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
              bypass={route.bypass} // Pass bypass from route config
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return hrRoute.map((route) => renderRoute(route));
}
